var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tabs',{staticClass:"pp-tab-menu",on:{"change":_vm.onChange},model:{value:(_vm.tabName),callback:function ($$v) {_vm.tabName=$$v},expression:"tabName"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }